var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ele-chart',{attrs:{"option":_vm.option},on:{"done":_vm.onChartDone}})}
var staticRenderFns = []

export { render, staticRenderFns }